import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Iterates over each entry in the provided dictionary. The iterator allows
 * to remove elements and will stop when the callback returns {{false}}.
 */

export function forEach(from, callback) {
  var _loop = function _loop(key) {
    if (hasOwnProperty.call(from, key)) {
      var result = callback({
        key: key,
        value: from[key]
      }, function () {
        delete from[key];
      });

      if (result === false) {
        return {
          v: void 0
        };
      }
    }
  };

  for (var key in from) {
    var _ret = _loop(key);

    if (typeof _ret === "object") return _ret.v;
  }
}
export var SetMap = /*#__PURE__*/function () {
  function SetMap() {
    _classCallCheck(this, SetMap);

    this.map = new Map();
  }

  _createClass(SetMap, [{
    key: "add",
    value: function add(key, value) {
      var values = this.map.get(key);

      if (!values) {
        values = new Set();
        this.map.set(key, values);
      }

      values.add(value);
    }
  }, {
    key: "delete",
    value: function _delete(key, value) {
      var values = this.map.get(key);

      if (!values) {
        return;
      }

      values.delete(value);

      if (values.size === 0) {
        this.map.delete(key);
      }
    }
  }, {
    key: "forEach",
    value: function forEach(key, fn) {
      var values = this.map.get(key);

      if (!values) {
        return;
      }

      values.forEach(fn);
    }
  }]);

  return SetMap;
}();